<template>
    <section>
        <v-card
            class="signPage"
            elevation="10"
        >
            <DisplayList
                :notif="notif"
                :screen_width="screen_width"
                :search="search"
                :sign="sign"
                :loading="loading"
                @changeStatSign="sign.status = false"
            >
                <template #backBtn>
                    <v-card-title style="margin: 0; padding: 10px 10px 10px 0;">
                        <div style="padding: 0">
                            <v-tooltip top>
                                <template #activator="{ on }">
                                    <v-btn
                                        icon
                                        class="white--text"
                                        color="teal darken-1"
                                        v-on="on"
                                        @click="$emit('handleBackToMain')"
                                    >
                                        <v-icon>{{ mdiArrowLeft }}</v-icon>
                                    </v-btn>
                                </template>
                                <span>Back</span>
                            </v-tooltip>
                        </div>
                        List of Generated Endorsement and Confirmation
                        <v-spacer />
                        <div
                            class="search-wrapper"
                            :style="{
                                width: hovering || search.value !== null ? '40vh' : '20vh',
                                transition: 'width 0.4s ease'
                            }"
                            @mouseenter="hovering = true"
                            @mouseleave="hovering = false"
                        >
                            <v-text-field
                                v-model="search.query"
                                clearable
                                dense
                                placeholder="Search ..."
                                hide-details
                                color="teal darken-1"
                                :append-icon="mdiMagnify"
                                style="width: 100%;"
                                @click:clear="search.value = null"
                                @keydown.enter.prevent="search.value = search.query"
                                @click:append="search.value = search.query"
                            />
                        </div>
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    class="white--text"
                                    color="teal darken-1"
                                    style="min-width: 0; width: 10px; padding: 17px 21px; margin-left: 20px;"
                                    :disabled="sign.status"
                                    :loading="loading.signed"
                                    v-on="on"
                                    @click="sign.status = true"
                                >
                                    <v-icon>{{ mdiReload }}</v-icon>
                                </v-btn>
                            </template>
                            <span>Refresh</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template #activator="{ on }">
                                <v-btn
                                    v-if="isAdmin"
                                    color="teal darken-1 white--text"
                                    style="min-width: 0; width: 10px; padding: 17px 21px; margin-left: 10px"
                                    v-on="on"
                                    @click="showReport = !showReport"
                                >
                                    <v-icon>{{ mdiChartBarStacked }}</v-icon>
                                </v-btn>
                            </template>
                            <span>Generate Letter Report</span>
                        </v-tooltip>
                    </v-card-title>
                </template>
            </DisplayList>
        </v-card>
        <GenerateLetter
            :show="showReport"
            :notif="notif"
            :screen_width="screen_width"
            @closeDialog="showReport = !showReport"
        />
    </section>
</template>

<script>
import GenerateLetter from './GenerateLetter.vue'
import DisplayList from './DisplayList.vue'
import {
    mdiArrowLeft,
    mdiMagnify,
    mdiReload,
    mdiChartBarStacked
} from '@mdi/js'
export default {
    components: { DisplayList, GenerateLetter },
    props: ['notif', 'screen_width'],
    data:()=>({
        mdiArrowLeft,
        mdiMagnify,
        mdiReload,
        mdiChartBarStacked,
        loading: {
            signed: false,
            data: null,
            view: false
        },
        sign: { status: false },
        showReport: false,
        hovering: false,
        search: {
            value: null,
            query: null
        }
    }),
    computed: {
        isAdmin() {
            return this.$cookies.get('user_type') === 'admin'
        }
    },
    watch: {
        'search.query'(newVal) {
            if (newVal === '') {
                this.search.value = null
            }
        }
    }
}
</script>

<style scoped>
.signPage {
    padding:  2% 3% 3% 3%;
    margin: 2% auto 0 auto;
}
</style>
